import { render } from "./ChooseAddress.vue?vue&type=template&id=2de5db8e&scoped=true"
import script from "./ChooseAddress.vue?vue&type=script&lang=js"
export * from "./ChooseAddress.vue?vue&type=script&lang=js"

import "./ChooseAddress.vue?vue&type=style&index=0&id=2de5db8e&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de5db8e"]])

export default __exports__